<script setup lang="ts">
withDefaults(defineProps<{ projectKey: string; color: string; size?: 'md' | 'lg' }>(), {
  size: 'md',
});
</script>

<template>
  <span
    class="project-icon project-color"
    :class="[`project-color--${color}`, { 'project-icon--lg': size === 'lg' }]"
    aria-hidden="true"
  >
    {{ projectKey.slice(0, size === 'lg' ? 3 : 1) }}
  </span>
</template>
